import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthServiceService } from '@edtech-ui/core/services/authService/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

@Directive({
	selector: '[hasPermission]',
	standalone: true
})
export class HasPermissionDirective implements OnInit, OnDestroy {

	@Input('hasPermission') permission!: string | string[];
	private subscription = new Subscription();

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef,
		private _authService: AuthServiceService,
		private _toastr: ToastrService,
	) { }

	ngOnInit() {
		this.subscription = this._authService.permissions$.subscribe(userPermissions => {
			this.viewContainer.clear();

			if (!this.permission) {
				return;
			}

			const requiredPermissions = Array.isArray(this.permission) ? this.permission : [this.permission];
			const hasAnyPermission = requiredPermissions.some(p => userPermissions.includes(p));

			if (hasAnyPermission) {
				this.viewContainer.createEmbeddedView(this.templateRef);
			}
		})
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

}